// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, serverTimestamp } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDS57CvUNb4D9HNvE1cHhewBgzGsVLQwK8",
  authDomain: "lux-app-f39e2.firebaseapp.com",
  projectId: "lux-app-f39e2",
  storageBucket: "lux-app-f39e2.firebasestorage.app",
  messagingSenderId: "479640199817",
  appId: "1:479640199817:web:aed04b19074781ef8fdc58",
  measurementId: "G-K9BTLH02WB"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const db = getFirestore(app);
export { serverTimestamp };